<div class="slider" *ngIf="loaderService.isLoading.value">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
</div>
<router-outlet></router-outlet>